import { Box, Text } from "@chakra-ui/react";
import { useState } from "react";
import { Link } from "react-router-dom";

const HoverBox = ({ text, image, link }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <Box
            as={Link}
            to={link}
            position="relative"
            display="flex"
            justifyContent="center"
            alignItems="center"

            w={{
                base: "100%",
                sm: "320px",
                md: "300px",
                lg: "340px",
            }}

            h={{
                base: "340px",
                md: "400px",
                lg: "430px",
            }}

            borderRadius="xl"
            backgroundImage={`url(${image})`}
            backgroundPosition="center"
            backgroundSize="cover"
            overflow="hidden"
            cursor="pointer"

            boxShadow="0 6px 24px rgba(0,0,0,0.10)"

            transition="all 0.3s ease"

            _hover={{
                transform: "translateY(0px)",
                boxShadow: "0 14px 32px rgba(0,0,0,0.16)",
            }}

            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Box
                position="absolute"
                inset="0"
                bg={
                    hovered
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.28)"
                }
                transition="background 0.3s ease"
            />
            <Box
                position="absolute"
                top="18px"
                left="18px"
                width={hovered ? "calc(100% - 36px)" : "0%"}
                height="2px"
                bg="white"
                transition="width 0.35s ease"
            />
            <Box
                position="absolute"
                top="18px"
                right="18px"
                width="2px"
                height={hovered ? "calc(100% - 36px)" : "0%"}
                bg="white"
                transition="height 0.35s ease"
            />
            <Box
                position="absolute"
                bottom="18px"
                left="18px"
                width={hovered ? "calc(100% - 36px)" : "0%"}
                height="2px"
                bg="white"
                transition="width 0.35s ease 0.18s"
            />
            <Box
                position="absolute"
                top="18px"
                left="18px"
                width="2px"
                height={hovered ? "calc(100% - 36px)" : "0%"}
                bg="white"
                transition="height 0.35s ease 0.18s"
            />
            <Text
                position="relative"
                zIndex={2}

                px={6}

                fontFamily="'Poppins', sans-serif"

                fontSize={{
                    base: "lg",
                    md: "xl",
                    lg: "2xl",
                }}

                fontWeight="600"

                lineHeight="1.35"

                textAlign="center"

                color="white"

                textShadow="0 2px 8px rgba(0,0,0,0.7)"

                transform={
                    hovered
                        ? "translateY(0px)"
                        : "translateY(0)"
                }

                transition="all 0.3s ease"
            >
                {text}
            </Text>

        </Box>
    );
};

export default HoverBox;